import Vue from "vue";

// axios
import axios from "axios";
import { _errorHandler } from "@/utils/helpers";
import router from "@/router";

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: `${process.env.MIX_APP_URL}/api`,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});

axiosIns.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.setItem("twoFactorVerified", false);
      localStorage.removeItem("userData");
      _errorHandler(error, () => {
        router.replace({ name: "auth-login" });
      });
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
